import api from "../../utils/api";
import conf from "../../configs/index";

const SET_USER_INFO = 'account/SetUserInfo';
const SET_AUTHORIZATION = 'account/SetAuthorization';

import {
    LOGIN,
    LOGOUT,
    AUTHORIZE,
    ACCOUNT
} from '../types';
export default {
    state: {
        user: null,
        /**
         * {
         *   "token_type": "Bearer",
         *   "expires_in": 604800,
         *   "access_token": "..."
         * }
         */
        authorization: null,
        loggedIn: false
    },
    mutations: {
        [SET_USER_INFO](state, user){
            state.user = user;
            state.loggedIn = !!user;
        },
        [SET_AUTHORIZATION](state, authorization){
            state.authorization = authorization;
            state.authorization.expires_in = Date.now() + state.authorization.expires_in;
        }
    },
    actions: {
        //cc:login#1;cell global login function;
        async [LOGIN]({commit}, account){
            sessionStorage.clear();
            const { actionPermission:action, resourcePermission:resource , ...data } = await api.login(account);
            const permission = resource.reduce((result, resource)=>({ ...result, [resource.name] : action.filter(i=>i.resourceName==resource.name).map(i=>i.actionName) }), {})
            commit(SET_USER_INFO, data);
            commit(SET_AUTHORIZATION, { permission, expires_in: 2*60*1000 });
        },
        async [LOGOUT]({ commit }, silent=false){
            if (!silent) { //授权过期后台将清理记录，无需手动清理
                api.logout();
            }
            commit(SET_USER_INFO, null);
        },
        async [AUTHORIZE]({commit}){
            const result = await api.authorize(conf.auth);
            commit(SET_AUTHORIZATION, result);
            return Promise.resolve(result);
        }
    },
    getters: {
        [ACCOUNT](state){
            return state.user;
        }
    }
}
